module.exports = __webpack_public_path__ + "img/verify-email-error.a96d2aa9.svg";